/**
 * Temporary chat ID is needed, when the chat is not created yet,
 * but we already want to show initial or local chat messages.
 */
export const TEMPORARY_CHAT_ID = "TEMPORARY_CHAT_ID";
